import {GenericDgSearchResults} from "./generic.dg-search-results.model";
import {WellnessPlan} from "../wellness-plan.model";

export class WellnessPlanDgSearchResults extends GenericDgSearchResults {
  public results: WellnessPlan[];

  constructor(total: number, results: WellnessPlan[], csrfToken: string) {
    super();
    this.total = total;
    this.results = results;
    this.csrfToken = csrfToken;
  }
}
